module.exports = __webpack_public_path__ + "img/Group 7852.1ce252e2.svg";